import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { throttle } from "lodash";
import { Helmet } from "react-helmet";
import qs from "qs";
import {
  campaignsList,
  campaignsListNext,
  emailsList,
  emailsListNext,
  emailsListClear,
  openModal,
} from "../../actions";
import Table from "../../components/Table";
import CampaignListItem from "../../components/CampaignListItem";
import EmailListItem from "../../components/EmailListItem";
import NonIdealState from "../../components/NonIdealState";
import Pin from "../../components/Pin";
import ListCampaignToolbar from "./ListCampaignToolbar";

const identity = (data) => data;

export class ListCampaignPage extends Component {
  constructor(props) {
    super(props);
    this.renderCampaign = this.renderCampaign.bind(this);
    this.renderEmail = this.renderEmail.bind(this);
    this.onClone = this.onClone.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onScroll = throttle(this.onScroll.bind(this), 60);

    this.state = {
      deleteOpen: true,
      campaignName: "",
    };
  }

  componentWillMount() {
    const searchTerm =
      this.props.query.name && this.props.query.name.length > 0
        ? this.props.query.name
        : undefined;

    this.props.campaignsList(
      this.props.match.params.accountId,
      Object.assign(
        {},
        searchTerm
          ? undefined
          : {
              campaign: "root",
            },
        this.props.query
      ),
      searchTerm ? false : "root",
      true
    );

    if (searchTerm) {
      this.props.emailsList(
        this.props.match.params.accountId,
        this.props.query,
        true
      );
    } else {
      this.props.emailsListClear();
    }

    this.fetchMore = this.fetchMore.bind(this);
    window.addEventListener("scroll", this.onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  }

  onClone(emailId) {
    this.props.openModal("clone-email", {
      id: emailId,
      accountId: this.props.match.params.accountId,
    });
  }

  onDelete(campaignId) {
    this.props.openModal("delete-campaign", {
      id: campaignId,
      accountId: this.props.match.params.accountId,
    });
  }

  fetchMore() {
    this.props.campaignsListNext(this.props.match.params.accountId);
  }

  onScroll(e) {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight || document.body.clientHeight;
    if (scrollTop + window.innerHeight > scrollHeight - 50) {
      this.props.campaignsListNext(this.props.match.params.accountId);
      this.props.emailsListNext(this.props.match.params.accountId);
    }
  }

  renderCampaign(campaign) {
    return (
      <CampaignListItem
        campaign={campaign}
        key={campaign.id}
        accountId={this.props.match.params.accountId}
        onDelete={this.onDelete}
        onClone={this.onClone}
      />
    );
  }

  renderEmail(email) {
    return (
      <EmailListItem
        email={email}
        key={email.id}
        accountId={this.props.match.params.accountId}
        onDelete={this.onDelete}
        onClone={this.onClone}
      />
    );
  }

  renderFetching() {
    return <div>Fetching</div>;
  }

  render() {
    const { campaigns, emails, isFetching } = this.props;

    return (
      <div>
        <Helmet>
          <title>{`Mercury - List Campaigns`}</title>
        </Helmet>
        <Pin y={50}>
          <ListCampaignToolbar
            accountId={this.props.match.params.accountId}
            searchTerm={this.props.query.name}
          />
        </Pin>
        {campaigns.length > 0 ? (
          <Table
            renderItem={this.renderCampaign}
            items={campaigns}
            isFetching={isFetching}
            loadMore={this.fetchMore}
            renderFetching={this.renderFetching}
          />
        ) : undefined}
        {emails.length > 0 ? (
          <Table
            renderItem={this.renderEmail}
            items={emails}
            isFetching={isFetching}
            loadMore={this.fetchMore}
            renderFetching={this.renderFetching}
          />
        ) : undefined}
        {campaigns.length === 0 && emails.length === 0 && !isFetching ? (
          <NonIdealState title="No Campaigns Found" visual="warning" />
        ) : undefined}
        {isFetching ? (
          <NonIdealState title="Loading" visual="refresh" spin />
        ) : undefined}
      </div>
    );
  }
}

ListCampaignPage.propTypes = {
  params: PropTypes.object,
  campaignsList: PropTypes.func.isRequired,
  campaignsListNext: PropTypes.func.isRequired,
  campaigns: PropTypes.array.isRequired,
  openModal: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
};

// Connect state data
function mapStateToProps(state, ownProps) {
  const query = qs.parse(ownProps.location.search, { ignoreQueryPrefix: true });
  const campaignsPagination = query.name
    ? state.pagination.campaigns || {}
    : state.pagination.campaignsByParent["root"] || {};
  const campaigns = (campaignsPagination.ids || [])
    .map((id) => state.entities.campaign[id])
    .filter(identity);

  const emailsPagination = state.pagination.emails || {};
  const emails = (emailsPagination.ids || [])
    .map((id) => state.entities.email[id])
    .filter(identity);

  const isFetching =
    emailsPagination.isFetching || campaignsPagination.isFetching;

  return {
    query,
    campaigns,
    emails,
    isFetching,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  campaignsList,
  campaignsListNext,
  emailsList,
  emailsListNext,
  emailsListClear,
  openModal,
})(ListCampaignPage);
